import(/* webpackMode: "eager" */ "/vercel/path1/src/app/error.tsx");
